import { $Q, stringToHTML } from "graditify-utils";
import api from "../services/api";

export class DynamicSection extends HTMLElement {
  constructor() {
    super()
    this.section = this.getAttribute('section-name')
    this.key = this.getAttribute('key')
    this.base = this.getAttribute('base')
    this.areImages = this.getAttribute('images') === 'true'
  }

  static get observedAttributes() {
    return ['variant']
  }

  /**
   * 'variant' attribute changed
   *
   * @param {String} prop - Attribute was changed
   * @param {String} oldValue - Attribute old value
   * @param {String} newValue - Attribute new value
   * @returns {Void}
   */
  attributeChangedCallback(prop, oldValue, newValue) {
    if (newValue === "" && oldValue === newValue) return

    if (prop === 'variant') {
      this.updateContent(newValue);
    }
  }

  /**
   * Save content from metafield key
   * @param {String} variant - Variant id reference
   */
  async updateContent(variant) {
    const params = `?section_id=${this.section}&variant=${variant}`
    const sectionAPI = await api.shopifySectionWithParams(this.base, params)

    const parent = stringToHTML(sectionAPI)
    const metafields = JSON.parse($Q('[name="metafields"]', parent).value)

    if (this.areImages) {
      const metafieldImages = this.displayImages(metafields[`${this.key}`])
      return this.replaceHTML(metafieldImages)
    }

    return this.replaceHTML(metafields[`${this.key}`])
  }

  /**
   * Replace content in HTML
   * @param {String} container - Metafield content
   */
  replaceHTML(container) {
    const shopifySection = this.closest('.shopify-section')

    if (container) {
      shopifySection.style.display = 'block'
      this.innerHTML = container;
    } else {
      shopifySection.style.display = 'none'
    }
  }

  /**
   * Convert string in images list (HTMLElements)
   * @param {String} str - Images url separate with (,)
   * @returns {HTMLElement}
   */
  displayImages(str) {
    if (!str) return null;

    const images = str.split(',')
    let html = '';

    images.forEach((img, i) => {
      html += `<picture>
        <img
          src="${img}"
          height="90"
          width="90"
          alt="icon render ${i}"
          loading="lazy"
        />
      </picture>`
    })

    return html
  }
}
